// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CrmUserApiModel from "../api-model/CrmUserApiModel.bs.js";
import * as DeccoUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";

function decodeLoggedInUser(user) {
  return {
          name: user.admin.name,
          id: user.admin.id,
          email: user.admin.email,
          crt_id: user.admin.crt_id
        };
}

function execute(json) {
  return decodeLoggedInUser(DeccoUtils$Catalyst.resolveResult(CrmUserApiModel.t_decode(json), "CrmUserEntityMapper.re"));
}

export {
  decodeLoggedInUser ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
